<!-- 基金档案 -->
<template>
  <div :style="borderStyle" class="archives-box">
    <!-- 顶部 -->
    <div class="header">
      <div class="title">基金档案</div>
      <div class="desc" @click="clickMore">概况、持仓、规模、分红</div>
      <img :src="RIGHT_ARROW" class="arrow" @click="$goFundApp"/>
    </div>
    <!-- 基本信息 -->
    <div class="basic-info">
      <div v-for="(item, index) in basicList" :key="index" class="basic-info-item">
        <div class="title-box" @click="$goFundApp">
          <div class="title">{{item.desc}}</div>
          <img :src="RIGHT_ARROW" class="arrow"/>
        </div>
        <div class="value">{{item.value}}</div>
      </div>
    </div>
    <!-- 基金经理 -->
    <fund-manager-list :detail-info="detailInfo" />
    <!-- 投资理念 -->
    <div v-if="!$isEmpty(investIdea) && !$isEmpty(investIdea.investmentIdea)" class="invest">
      <div class="title">投资理念</div>
      <div class="idea">{{investIdea.investmentIdea}}</div>
      <img
        v-if="!$isEmpty(investIdea.investmentIdeaImg)"
        :src="investIdea.investmentIdeaImg"
        class="idea-img" />
    </div>
  </div>
</template>

<script>
import FundManagerList from './FundManagerList.vue';

export default {
  name: 'fund-archives',

  components: { FundManagerList },

  props: {
    basicInfo: {
      type: Object,
      default: () => ({}),
    },
    detailInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      RIGHT_ARROW: 'https://j5.dfcfw.com/sc/image/202305/20230529052234.png',
    };
  },

  computed: {
    borderStyle() {
      return this.basicInfo?.isNewFund ? {
        'border-radius': '6px',
      } : {};
    },
    basicList() { // 基本信息
      const {
        company = '', companyId = '', estabDate = '', fundSize = '',
      } = this.detailInfo?.fundArchives || {};
      return [{
        desc: '基金公司',
        value: company,
        id: companyId,
      },
      {
        desc: '成立日期',
        value: estabDate,
      },
      {
        desc: '基金规模',
        value: fundSize,
      }];
    },
    investIdea() { // 投资理念
      return this.detailInfo?.investIdea || {};
    },
  },

  methods: {
    clickMore() {
      window.sendTrackLog('Div', 'Click', 'xpzy.pzy.jjda.click', '');
      this.$goFundApp();
    },
  },
};
</script>

<style lang="less" scoped>
.archives-box {
  width: 100%;
  box-sizing: border-box;
  padding: 40px 24px 32px;
  border-radius: 12px 12px 0 0;
  background-color: #fff;
  margin-top: 24px;
  .arrow {
    width: 32px;
    height: 32px;
    margin-left: 8px;
  }
  .header {
    display: flex;
    flex-direction: row;
    align-items: center;
    .title {
      font-size: 36px;
      color: #000000;
      line-height: 36px;
      font-weight: 700;
    }
    .desc {
      font-size: 28px;
      color: #666666;
      flex: 1;
      text-align: right;
    }
  }
  .basic-info {
    display: flex;
    flex-direction: row;
    margin-top: 64px;
    padding-bottom: 32px;
    border-bottom: 1px solid #eeeeee;
    .basic-info-item {
      width: 33%;
      .title-box {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: left;
        .title {
          font-size: 28px;
          color: #666666;
        }
      }
      .value {
        margin-top: 16px;
        font-size: 30px;
        color: #000000;
        white-space: nowrap; /* 不换行 */
        overflow: hidden; /* 超出部分隐藏 */
        text-overflow: ellipsis; /* 显示省略号 */
        font-family: DINAlternate-Bold;
      }
    }
    .basic-info-item:nth-child(2)  {
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .basic-info-item:last-child  {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
    }
  }
  .invest {
    border-top: 1px solid #eeeeee;
    padding-top: 32px;
    .title {
      font-size: 28px;
      color: #666666;
      line-height: 28px;
    }
    .idea {
      font-size: 30px;
      color: #000000;
      line-height: 50px;
      margin-top: 24px;
    }
    .idea-img {
      width: 100%;
      margin-top: 24px;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
}
</style>
